/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {VisibilityEventModel} from '../../core/_models'

type Props = {
  visibilityEvent: VisibilityEventModel
}

const VisibilityEventLinkCell: FC<Props> = ({visibilityEvent}) => {

  return(
  <div className='d-flex align-items-center'>
    <div className='d-flex flex-column'>
      <a  className='text-gray-800 text-hover-primary mb-1'>
        {visibilityEvent.link ? visibilityEvent.link : ""}
      </a>
    
    </div>
  </div>     

)}
export {VisibilityEventLinkCell}
